import React, { useState, useEffect } from "react";

const GreetingNoteSection = ({
  isGreetingNoteChecked,
  setIsGreetingNoteChecked,
  isGreetingNoteText,
  setIsGreetingNoteText,
  selectedGreetingCard,
  setSelectedGreetingCard,
}) => {
  const [greetingCards, setGreetingCards] = useState([]);

  // Fetch greeting cards
  const fetchGreetingCards = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/email-templates/greeting-card-list`,
        {
          method: "GET",
        }
      );
      const data = await response.json();
      if (data.success) {
        setGreetingCards(data.responseObject);
      }
    } catch (error) {
      console.error("Error fetching greeting cards:", error);
    }
  };

  useEffect(() => {
    fetchGreetingCards();
  }, []);

  const handleCardClick = (cardBanner) => {
    // Toggle the selection of the card
    if (selectedGreetingCard === cardBanner) {
      setSelectedGreetingCard(null); // Unselect the card
    } else {
      setSelectedGreetingCard(cardBanner); // Select the card
    }
  };

  return (
    <div className="card border-0 shadow-sm h-100">
      <div className="card-header bg-white py-3">
        <h4 className="mb-0 fs-5">
          <i className="fas fa-sticky-note me-2"></i>
          Greeting Note
        </h4>
      </div>
      <div className="card-body">
        <div className="form-check mb-3">
          <input
            className="form-check-input"
            type="checkbox"
            id="greetingNote"
            checked={isGreetingNoteChecked}
            onChange={(e) => setIsGreetingNoteChecked(e.target.checked)}
          />
          <label className="form-check-label" htmlFor="greetingNote">
            Add Greeting Note
          </label>
        </div>
        {isGreetingNoteChecked && (
          <>
            <textarea
              className="form-control mb-3"
              onChange={(e) => setIsGreetingNoteText(e.target.value)}
              value={isGreetingNoteText}
              placeholder="Add your greeting message..."
              rows="3"
              maxLength={1000}
              style={{
                minHeight: "120px",
                resize: "vertical",
              }}
            />
            <div className="greeting-cards mt-4">
              <h6 className="mb-3">Select a Greeting Card</h6>
              <div className="greeting-cards-container">
                <div className="d-flex gap-3">
                  {greetingCards.map((card, index) => (
                    <div
                      key={index}
                      className="greeting-card-wrapper"
                      style={{
                        width: "120px",
                        height: "120px",
                        flexShrink: 0,
                      }}
                    >
                      <div
                        className={`greeting-card-item ${
                          selectedGreetingCard === card.banner ? "selected" : ""
                        }`}
                        onClick={() => handleCardClick(card.banner)}
                      >
                        <img
                          src={card.banner}
                          alt={`Greeting Card ${index + 1}`}
                          className="img-fluid rounded"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            border:
                              selectedGreetingCard === card.banner
                                ? "2px solid #3c3260"
                                : "1px solid #dee2e6",
                            transition: "all 0.3s ease-in-out",
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <style>
        {`
          @media (max-width: 768px) {
            .greeting-cards-container {
              overflow-x: auto;
              -webkit-overflow-scrolling: touch;
              padding-bottom: 10px;
            }
            
            .greeting-cards-container::-webkit-scrollbar {
              height: 6px;
            }
            
            .greeting-cards-container::-webkit-scrollbar-track {
              background: #f1f1f1;
              border-radius: 10px;
            }
            
            .greeting-cards-container::-webkit-scrollbar-thumb {
              background: #3c3260;
              border-radius: 10px;
            }
            
            .greeting-card-wrapper {
              min-width: 120px;
            }
            
            textarea {
              min-height: 100px !important;
            }
          }
          
          .greeting-card-item {
            cursor: pointer;
            transition: transform 0.2s ease;
          }
          
          .greeting-card-item:hover {
            transform: scale(1.05);
          }
          
          .greeting-card-item.selected {
            transform: scale(1.05);
            box-shadow: 0 0 10px rgb(74, 55, 139);
          }
        `}
      </style>
    </div>
  );
};

export default GreetingNoteSection;
